const legalbirdTipTapEditorStyles = {
  defaultEditor: { border: "1px solid #dadada", borderRadius: "5px", padding: ".5rem 1rem", minHeight: "20rem" },
};

export default legalbirdTipTapEditorStyles;
